import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { BudgetDashboard } from "@/components/budget/BudgetDashboard";
import { Button } from "@/components/ui/button";

const Budget = () => {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <DashboardLayout userType="owner">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold">Budget</h1>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsVisible(!isVisible)}
            className="text-muted-foreground hover:text-foreground"
          >
            {isVisible ? (
              <EyeOff className="h-5 w-5" />
            ) : (
              <Eye className="h-5 w-5" />
            )}
          </Button>
        </div>
        
        {isVisible && (
          <BudgetDashboard />
        )}
      </div>
    </DashboardLayout>
  );
};

export default Budget;